function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { HttpClient } from '@wix/http-client';
import URI from 'urijs';
import { Wix, window } from '@wix/photography-client-lib';
import { utils } from './utils/utils';
var httpClient = new HttpClient();
export var WixStoreApi = /*#__PURE__*/function () {
  function WixStoreApi(instanceId, _instance, locale, wixApi, protocol) {
    _defineProperty(this, "publishStore", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(instance) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return httpClient.post("https://progallery.wix.com/api/v1/store/publish?isStore=true&instance=" + instance, JSON.stringify({}), {
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
              });
            case 3:
              _context.next = 8;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.log({
                e: _context.t0
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 5]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    this.connectedProvidersCache = null;
    this.galleryDataPromise = null;
    this.instanceId = instanceId;
    this.instance = _instance;
    this.locale = locale;
    this.wixApi = wixApi;
    this.protocol = protocol;
    this.httpClient = new HttpClient({
      withCredentials: true,
      headers: {
        Authorization: _instance
      }
    });
  }
  var _proto = WixStoreApi.prototype;
  _proto.getStoreGalleryData = function getStoreGalleryData(ignoreCache) {
    var _this = this;
    if (ignoreCache === void 0) {
      ignoreCache = false;
    }
    this.getStorePurchasesHistory();
    if (!this.connectedProvidersCache && this.galleryDataPromise) {
      return this.galleryDataPromise;
    } else if (this.connectedProvidersCache && !ignoreCache) {
      this.galleryDataPromise = Promise.resolve(this.connectedProvidersCache);
    } else {
      this.galleryDataPromise = this.sendRequest('GET', "gallery/" + this.instanceId + "/providers", null).then(function (response) {
        _this.connectedProvidersCache = response;
        return _this.connectedProvidersCache;
      });
    }
    return this.galleryDataPromise;
  };
  _proto.getStorePurchasesHistory = function getStorePurchasesHistory() {
    return this.httpClient.get("" + this.protocol + utils.getBaseUrl() + "/_api/pro-gallery-webapp/v1/purchase", {
      params: {
        instance: this.instance,
        locale: this.locale,
        deviceType: 'desktop',
        cachekiller: new Date().getTime(),
        isStore: true
      },
      headers: {
        'Content-Type': 'application/json'
      }
    });
  };
  _proto.connectProvider = function connectProvider(providerId) {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      _this2.sendRequest('POST', "providers/" + providerId + "/connect", null).then(function (result) {
        _this2.getProviders().then(function (providersData) {
          if (providersData && Array.isArray(providersData.providers)) {
            var providersList = providersData.providers;
            var connectedProvider = providersList.find(function (providerData) {
              return providerData.providerId === providerId;
            });
            if (connectedProvider) {
              resolve({
                result: result,
                providers: providersData
              });
            } else {
              reject();
            }
          } else {
            reject();
          }
        });
      });
    });
  };
  _proto.getProviders = function getProviders() {
    return this.sendRequest('GET', 'providers/approved', null).then(function (response) {
      window.providers = response.providers;
      return response;
    });
  };
  _proto.sendRequest = function sendRequest(type, endpoint, data) {
    var url = new URI(this.getUrlPrefix() + endpoint).search({
      instance: this.instance,
      locale: this.locale,
      deviceType: 'desktop',
      cachekiller: new Date().getTime(),
      isStore: true
    });
    return this.httpClient.request({
      method: type,
      url: url.toString(),
      data: data,
      withCredentials: true,
      xsrfCookieName: null,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  };
  _proto.getUrlPrefix = function getUrlPrefix() {
    return this.protocol + utils.getBaseUrl() + '/_api/pro-gallery-editor-webapp/v1/';
  };
  _proto.generateUrl = function generateUrl(endpointFile, params) {
    params = params || {};
    var uri = new URI(this.getUrlPrefix() + endpointFile);
    uri.search(params);
    return uri.toString();
  };
  _proto.generateBizMgrArtStoreUrl = function generateBizMgrArtStoreUrl(metasiteId, siteUrl) {
    var EDITOR_X_MANAGE_BASE_URL = 'https://manage.editorx.com';
    var EDITOR_MANAGE_BASE_URL = 'https://www.wix.com';
    var baseUrl = siteUrl.includes('editorx') ? EDITOR_X_MANAGE_BASE_URL : EDITOR_MANAGE_BASE_URL;
    // eslint-disable-next-line new-cap
    var bizMgrUrl = URI(baseUrl).segment('dashboard').segment(metasiteId).segment('art-store').search({
      isEditor: true
    });
    return bizMgrUrl.toString();
  };
  _proto.getDashboardUrl = function getDashboardUrl(options) {
    var _this3 = this;
    return new Promise(function (resolve, reject) {
      var doReject = function doReject(message) {
        console.error(message);
        reject(message);
      };
      _this3.wixApi.Settings.getSiteInfo(function (siteInfo) {
        var siteUrl = siteInfo.url;
        _this3.wixApi.Settings.getDashboardAppUrl(function (url) {
          if (url) {
            var uriDashboardUrl = URI(url);
            var arrSegments = uriDashboardUrl.segment();
            var isValidSegment = Array.isArray(arrSegments) && arrSegments.length;
            if (isValidSegment) {
              var metasiteId = null;
              var isMyAccountIndex = arrSegments.indexOf('my-account');
              var isBizMgrIndex = arrSegments.indexOf('dashboard');
              if (isMyAccountIndex !== -1) {
                metasiteId = arrSegments[isMyAccountIndex + 2]; // format www.wix.com/my-account/sites/[metasite id]/app/[appDefId]
              } else if (isBizMgrIndex !== -1) {
                metasiteId = arrSegments[isBizMgrIndex + 1]; // format www.wix.com/dashboard/[metasite id]
              } else {
                doReject("getDashboardUrl - Invalid dashboard url (unknown): " + url);
              }
              if (metasiteId) {
                var bizMgrUrl = _this3.generateBizMgrArtStoreUrl(metasiteId, siteUrl);
                resolve({
                  url: bizMgrUrl.toString(),
                  title: undefined
                });
              }
            } else {
              doReject("getDashboardUrl - Invalid dashboard url (format): " + url);
            }
          } else {
            doReject("getDashboardUrl - No url");
          }
        });
      });
    });
  };
  _proto.openDashboard = function openDashboard(options) {
    var _this4 = this;
    if (options === void 0) {
      options = {};
    }
    return new Promise(function (resolve, reject) {
      _this4.getDashboardUrl(options).then(function (_ref3) {
        var url = _ref3.url,
          title = _ref3.title;
        _this4.wixApi.Settings.openModal(url, '100%', '100%', title, resolve, !title, {
          overlay: 'rgba(0,0,0,0)',
          background: 'rgba(0,0,0,0)',
          margin: '0px 0px 0px 0px',
          padding: false
        });
      })["catch"](function (message) {
        reject(message);
      });
    });
  };
  _proto.getProviderModalUrl = function getProviderModalUrl(params) {
    if (params === void 0) {
      params = {};
    }
    var queryParams = Object.assign({}, params, {
      isStore: true
    });
    var uri = new URI(this.protocol + "//progallery.wixapps.net/pro-gallery-webapp/provider-modal.html");
    var url = uri.search(queryParams).toString();
    return url;
  };
  _proto.openProviderModal = function openProviderModal(name, connectedProviders, options, containerParams) {
    var _this5 = this;
    if (options === void 0) {
      options = {};
    }
    if (containerParams === void 0) {
      containerParams = {};
    }
    return new Promise(function (resolve, reject) {
      if (name) {
        var providerId = Object.keys(connectedProviders)[0];
        var providerData = connectedProviders[providerId];
        var widgets = providerData.widgets;
        if (widgets[name]) {
          var objAdditionalParams = _this5.getProviderUrlOptions(options);
          var finalParams = Object.assign({
            name: name
          }, objAdditionalParams, containerParams);
          var providerModalUrl = _this5.getProviderModalUrl(finalParams);
          _this5.wixApi.openPopup(providerModalUrl, '100%', '100%', {
            origin: _this5.wixApi.WindowOrigin.FIXED,
            placement: _this5.wixApi.WindowPlacement.CENTER
          }, function () {
            console.log('Provider modal closed', providerId);
          }, _this5.wixApi.Theme.BARE);
          resolve();
        } else {
          reject("Name '" + name + "' does not exist in widgets", providerId);
        }
      } else {
        reject('Name not defined');
      }
    });
  };
  _proto.getProviderUrlOptions = function getProviderUrlOptions(options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      urlParams = _options.urlParams,
      urlPath = _options.urlPath;
    var objAdditionalParams = {
      urlParams: '{}',
      urlPath: '/'
    };
    if (urlParams && typeof urlParams === 'object') {
      var encodedParams = JSON.stringify(urlParams);
      objAdditionalParams.urlParams = encodedParams;
    }
    if (urlPath && typeof urlPath === 'string') {
      objAdditionalParams.urlPath = urlPath;
    }
    return objAdditionalParams;
  };
  return WixStoreApi;
}();
var storeApi = null;
if (typeof window !== 'undefined') {
  storeApi = new WixStoreApi(window.instanceId, window.instance, window.locale, Wix, window.location.protocol);
  window.WixStoreApi = storeApi;
}
export default storeApi;